import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import type { UtilityReadingsResponse } from '../api/contracts';

export * from './utilityTransforms';

/**
 * GET /api/utility?from=&to= — raw utility interval readings. This site has
 * no solar export (api/src/lib/tariff.ts convention 6: `kwhReceived` is
 * expected to stay ~0 throughout), but the API still returns the field and
 * consumers (see ./utilityTransforms.ts) must plot whatever comes back
 * rather than assuming or hardcoding zero — a meaningfully non-zero value
 * later would be a data-quality signal worth surfacing, not something to
 * silently render away.
 */
export function useUtility(from: string, to: string) {
  return useQuery({
    queryKey: ['utility', from, to],
    queryFn: () =>
      apiClient.get<UtilityReadingsResponse>(`/api/utility?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`),
    enabled: Boolean(from && to),
  });
}
